import React from 'react';
import { XIcon, UserIcon, GlobeIcon, MapPinIcon, BuildingIcon, MailIcon, BriefcaseIcon, FileTextIcon, TrendingUpIcon, TrendingDownIcon, BarChart4Icon, DollarSignIcon, PieChartIcon, CheckCircleIcon, ClockIcon, XCircleIcon, ArrowUpRightIcon, PlusIcon, UsersIcon, CalendarIcon, StarIcon } from 'lucide-react';
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
export function BusinessUnitUserModal({
  user,
  onClose
}) {
  if (!user) return null;
  // Datos de muestra para las cotizaciones del usuario
  const userQuoteStats = {
    total: 47,
    active: 18,
    pending: 12,
    approved: 10,
    expired: 7,
    totalValue: 1432500,
    winRate: 68,
    avgQuoteValue: 30479,
    changeFromLastMonth: 8.5
  };
  // Datos para el gráfico de tendencia del mercado
  const marketTrendData = [{
    month: 'Jan',
    value: 230000,
    prevValue: 210000
  }, {
    month: 'Feb',
    value: 280000,
    prevValue: 240000
  }, {
    month: 'Mar',
    value: 250000,
    prevValue: 270000
  }, {
    month: 'Apr',
    value: 310000,
    prevValue: 230000
  }, {
    month: 'May',
    value: 350000,
    prevValue: 290000
  }, {
    month: 'Jun',
    value: 320000,
    prevValue: 310000
  }, {
    month: 'Jul',
    value: 390000,
    prevValue: 320000
  }, {
    month: 'Aug',
    value: 420000,
    prevValue: 350000
  }];
  // Datos para el gráfico de distribución de cotizaciones
  const quoteDistributionData = [{
    name: 'Active',
    value: userQuoteStats.active,
    color: '#22c55e'
  }, {
    name: 'Pending',
    value: userQuoteStats.pending,
    color: '#eab308'
  }, {
    name: 'Approved',
    value: userQuoteStats.approved,
    color: '#3b82f6'
  }, {
    name: 'Expired',
    value: userQuoteStats.expired,
    color: '#ef4444'
  }];
  // Datos de distribuidores
  const dealersStats = {
    total: user.dealers.length,
    active: Math.floor(user.dealers.length * 0.85),
    newThisQuarter: 3,
    growthRate: 12.5,
    topPerformer: user.dealers[0],
    newDealers: [{
      name: 'AgriTech Solutions',
      location: user.countries[0],
      date: '2 months ago',
      sales: '$125,400'
    }, {
      name: 'Farm Innovations Ltd',
      location: user.countries[1],
      date: '3 months ago',
      sales: '$98,700'
    }, {
      name: 'Irrigation Experts',
      location: user.countries[2],
      date: '5 months ago',
      sales: '$76,300'
    }]
  };
  // Datos para el gráfico de rendimiento por país
  const countryPerformanceData = user.countries.map(country => ({
    country,
    value: Math.floor(Math.random() * 200000) + 50000,
    quota: Math.floor(Math.random() * 250000) + 100000
  })).sort((a, b) => b.value - a.value);
  return <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4" data-id="element-3492" data-mp="3agnol44sumq0">
      <div className="bg-slate-800 rounded-xl border border-slate-700 shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-auto" onClick={e => e.stopPropagation()} data-id="element-3493" data-mp="3obzjbbiygd6x">
        {/* Header */}
        <div className="p-5 border-b border-slate-700 flex justify-between items-center sticky top-0 bg-slate-800 z-10" data-id="element-3494" data-mp="6tk7rys4cgqk">
          <h2 className="text-xl font-bold text-white flex items-center" data-id="element-3495" data-mp="3u0ctrfrzo0mz">
            <UserIcon size={20} className="mr-2 text-indigo-400" data-id="element-3496" data-mp="3u2gwvvi2cvm7" />
            Business Unit User Details
          </h2>
          <button className="text-slate-400 hover:text-white bg-slate-700/50 hover:bg-slate-700 rounded-full p-1.5" onClick={onClose} data-id="element-3497" data-mp="3kajiygzo7pjs">
            <XIcon size={18} data-id="element-3498" data-mp="3p1jjdw800pr1" />
          </button>
        </div>
        {/* User Info */}
        <div className="p-6" data-id="element-3499" data-mp="3baekwxgda3ia">
          <div className="flex flex-col md:flex-row md:items-start gap-4 mb-6" data-id="element-3500" data-mp="3bbfzvd0i7a5a">
            {/* Left: Avatar + Identity */}
            <div className="flex items-center flex-shrink-0" data-id="element-3501" data-mp="3f9drsnlnsacd">
              <div className="w-14 h-14 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center text-white text-xl font-semibold mr-4 ring-2 ring-indigo-400/30" data-id="element-3502" data-mp="31d07l6pqpuu7">
                {user.name.split(' ').map(name => name[0]).join('')}
              </div>
              <div data-id="element-3503" data-mp="8i9rgf0gr6ra">
                <h3 className="text-lg font-bold text-white leading-tight" data-id="element-3504" data-mp="8hqllwo388tm">
                  {user.name}
                </h3>
                <div className="flex items-center text-slate-300 text-sm mt-0.5" data-id="element-3505" data-mp="3o5jbsfgosom">
                  <BriefcaseIcon size={13} className="mr-1.5 text-slate-400" data-id="element-3506" data-mp="3uwjfgn0hecrj" />
                  {user.role}
                </div>
                <div className="flex items-center text-slate-300 text-sm mt-0.5" data-id="element-3507" data-mp="3kylss3y9so11">
                  <MailIcon size={13} className="mr-1.5 text-slate-400" data-id="element-3508" data-mp="3l0q251exuf8p" />
                  {user.email}
                </div>
              </div>
            </div>

            {/* Right: Business Unit + Coverage panels */}
            <div className="flex flex-col sm:flex-row gap-3 md:ml-auto" data-id="element-3509" data-mp="1f5doifxxmctu">
              {/* Assigned Business Unit */}
              <div className="bg-slate-700/50 rounded-lg p-3 border border-slate-600/50 min-w-[180px]" data-id="element-3510" data-mp="1a6astm3udiyj">
                <div className="flex items-center justify-between mb-1.5" data-id="element-3511" data-mp="1hqv3n8ibmdbj">
                  <span className="text-xs text-slate-400" data-id="element-3512" data-mp="1mowr05ms4yst">
                    Assigned Business Unit
                  </span>
                  <GlobeIcon size={14} className="text-indigo-400" data-id="element-3513" data-mp="1rgxyle9061ci" />
                </div>
                <div className="text-base font-bold text-white leading-tight" data-id="element-3514" data-mp="1wf98tq37mdv9">
                  {user.businessUnit}
                </div>
                <div className="flex flex-wrap gap-1.5 mt-2" data-id="element-3515" data-mp="yt2147bm05eo">
                  {user.regions.map(region => <span key={region} className="bg-indigo-900/30 text-indigo-300 border border-indigo-800/30 px-2 py-0.5 rounded text-[11px]" data-id="element-3516" data-mp="13qu3jv9vr9x4">
                      {region}
                    </span>)}
                </div>
              </div>

              {/* Coverage */}
              <div className="bg-slate-700/50 rounded-lg p-3 border border-slate-600/50 min-w-[180px]" data-id="element-3517" data-mp="2k3iosbdqs7eh">
                <div className="flex items-center justify-between mb-1.5" data-id="element-3518" data-mp="2o544s5lkp1sw">
                  <span className="text-xs text-slate-400" data-id="element-3519" data-mp="p0w07kgsgrff">Coverage</span>
                  <MapPinIcon size={14} className="text-amber-400" data-id="element-3520" data-mp="k2b1jph6qft3" />
                </div>
                <div className="flex items-center gap-4 mb-2" data-id="element-3521" data-mp="k4nflrjto60v">
                  <div data-id="element-3522" data-mp="y0snbhnj5i8d">
                    <div className="text-base font-bold text-white" data-id="element-3523" data-mp="xzzl8tzingwk">
                      {user.countries.length}
                    </div>
                    <div className="text-[11px] text-slate-400" data-id="element-3524" data-mp="5cwrsg9p5wd6">Countries</div>
                  </div>
                  <div className="w-px h-8 bg-slate-600" data-id="element-3525" data-mp="1ccr52px0ama"></div>
                  <div data-id="element-3526" data-mp="1a01s4htuxz7">
                    <div className="text-base font-bold text-white" data-id="element-3527" data-mp="f2y64gc900ew">
                      {user.dealers.length}
                    </div>
                    <div className="text-[11px] text-slate-400" data-id="element-3528" data-mp="abpwbj70ad17">Dealers</div>
                  </div>
                </div>
                <div className="flex flex-wrap gap-1.5" data-id="element-3529" data-mp="3iq86prkf64nz">
                  {user.countries.slice(0, 3).map(country => <span key={country} className="bg-amber-900/30 text-amber-300 border border-amber-800/30 px-2 py-0.5 rounded text-[11px]" data-id="element-3530" data-mp="3dr5dd4dsxmvu">
                      {country}
                    </span>)}
                  {user.countries.length > 3 && <span className="bg-slate-700 text-slate-300 border border-slate-600 px-2 py-0.5 rounded text-[11px]" data-id="element-3531" data-mp="1kar9ghp5b43e">
                      +{user.countries.length - 3} more
                    </span>}
                </div>
              </div>
            </div>
          </div>

          {/* KPI Summary Cards */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6" data-id="element-3532" data-mp="2h11l3vf9jbm6">
            <div className="bg-slate-700/50 rounded-lg p-3 border border-slate-600/50" data-id="element-3533" data-mp="230z7wmhwh6d9">
              <div className="flex items-center justify-between mb-1" data-id="element-3534" data-mp="233cyoj5jrwf0">
                <span className="text-xs text-slate-400" data-id="element-3535" data-mp="27yiklhyy9b33">Total Quotes</span>
                <FileTextIcon size={14} className="text-blue-400" data-id="element-3536" data-mp="rksds3gg48pr" />
              </div>
              <div className="text-xl font-bold text-white" data-id="element-3537" data-mp="wl6ojt9flwrh">
                {userQuoteStats.total}
              </div>
              <div className="text-xs text-green-400 flex items-center mt-1" data-id="element-3538" data-mp="1o99dxs072pma">
                <TrendingUpIcon size={12} className="mr-1" data-id="element-3539" data-mp="1j956erh9l587" />
                {userQuoteStats.changeFromLastMonth}% from last month
              </div>
            </div>
            <div className="bg-slate-700/50 rounded-lg p-3 border border-slate-600/50" data-id="element-3540" data-mp="19b8lj7yiyvww">
              <div className="flex items-center justify-between mb-1" data-id="element-3541" data-mp="19dld8cu34kn5">
                <span className="text-xs text-slate-400" data-id="element-3542" data-mp="26yg05p075zcu">Win Rate</span>
                <CheckCircleIcon size={14} className="text-green-400" data-id="element-3543" data-mp="21zmlht96c2b3" />
              </div>
              <div className="text-xl font-bold text-white" data-id="element-3544" data-mp="1x8o5kus3l68d">
                {userQuoteStats.winRate}%
              </div>
              <div className="text-xs text-green-400 flex items-center mt-1" data-id="element-3545" data-mp="1s9bg029udl23">
                <ArrowUpRightIcon size={12} className="mr-1" data-id="element-3546" data-mp="2ppqn5v2sxrzg" />
                3.2% from last quarter
              </div>
            </div>
            <div className="bg-slate-700/50 rounded-lg p-3 border border-slate-600/50" data-id="element-3547" data-mp="2kxfo0ufvya7y">
              <div className="flex items-center justify-between mb-1" data-id="element-3548" data-mp="2t8z8dbyeq149">
                <span className="text-xs text-slate-400" data-id="element-3549" data-mp="2x882ihxd010c">Total Value</span>
                <DollarSignIcon size={14} className="text-emerald-400" data-id="element-3550" data-mp="328cje926ixr3" />
              </div>
              <div className="text-xl font-bold text-white" data-id="element-3551" data-mp="3775xa2ldoqrs">
                ${(userQuoteStats.totalValue / 1000).toFixed(0)}k
              </div>
              <div className="text-xs text-slate-400 mt-1" data-id="element-3552" data-mp="3c5h7wfjhz5b2">
                Avg: ${userQuoteStats.avgQuoteValue.toLocaleString()}
              </div>
            </div>
            <div className="bg-slate-700/50 rounded-lg p-3 border border-slate-600/50" data-id="element-3553" data-mp="3kyu5vvwf4x40">
              <div className="flex items-center justify-between mb-1" data-id="element-3554" data-mp="3pxnkxsrcsw6a">
                <span className="text-xs text-slate-400" data-id="element-3555" data-mp="3pzrp8bt5zx73">Active Quotes</span>
                <ClockIcon size={14} className="text-amber-400" data-id="element-3556" data-mp="3uybdiiv8dl2m" />
              </div>
              <div className="text-xl font-bold text-white" data-id="element-3557" data-mp="3rid3h89hpz5">
                {userQuoteStats.active}
              </div>
              <div className="text-xs text-amber-400 flex items-center mt-1" data-id="element-3558" data-mp="1wx16mp1k55mu">
                <ClockIcon size={12} className="mr-1" data-id="element-3559" data-mp="20y387ciy5trz" />
                {userQuoteStats.pending} pending review
              </div>
            </div>
          </div>

          {/* Quote Statistics */}
          <div className="bg-slate-700/30 rounded-lg p-4 border border-slate-600/50 mb-6" data-id="element-3560" data-mp="2anwjecf6g6vp">
            <h4 className="text-white font-medium flex items-center mb-4" data-id="element-3561" data-mp="2fkwgvyxyo1b7">
              <FileTextIcon size={16} className="mr-2 text-blue-400" data-id="element-3562" data-mp="2kksoe85vaavi" />
              Quote Statistics
            </h4>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6" data-id="element-3563" data-mp="2ome6c7x9dfck">
              <div className="bg-slate-800/70 rounded-lg p-3" data-id="element-3564" data-mp="2tlh0uyfm436a">
                <div className="text-xs text-slate-400 mb-1" data-id="element-3565" data-mp="2tkxri6412n3v">Active Quotes</div>
                <div className="text-xl font-bold text-white flex items-center" data-id="element-3566" data-mp="u9wm797puvc5">
                  {userQuoteStats.active}
                  <span className="ml-2 text-xs px-1.5 py-0.5 bg-green-900/40 text-green-400 rounded-md" data-id="element-3567" data-mp="z9si0l69fggm">
                    {Math.round(userQuoteStats.active / userQuoteStats.total * 100)}
                    %
                  </span>
                </div>
              </div>
              <div className="bg-slate-800/70 rounded-lg p-3" data-id="element-3568" data-mp="hywzr28w1urz">
                <div className="text-xs text-slate-400 mb-1" data-id="element-3569" data-mp="czsqkblyrx1n">Pending</div>
                <div className="text-xl font-bold text-white flex items-center" data-id="element-3570" data-mp="1an17dtb0shxb">
                  {userQuoteStats.pending}
                  <span className="ml-2 text-xs px-1.5 py-0.5 bg-amber-900/40 text-amber-400 rounded-md" data-id="element-3571" data-mp="15ng5pb4gtvgw">
                    {Math.round(userQuoteStats.pending / userQuoteStats.total * 100)}
                    %
                  </span>
                </div>
              </div>
              <div className="bg-slate-800/70 rounded-lg p-3" data-id="element-3572" data-mp="3lf41323tzfxl">
                <div className="text-xs text-slate-400 mb-1" data-id="element-3573" data-mp="3lgf778kr0zrv">Approved</div>
                <div className="text-xl font-bold text-white flex items-center" data-id="element-3574" data-mp="3hcfxb8tz4z7h">
                  {userQuoteStats.approved}
                  <span className="ml-2 text-xs px-1.5 py-0.5 bg-blue-900/40 text-blue-400 rounded-md" data-id="element-3575" data-mp="3ivfrflibjtmb">
                    {Math.round(userQuoteStats.approved / userQuoteStats.total * 100)}
                    %
                  </span>
                </div>
              </div>
              <div className="bg-slate-800/70 rounded-lg p-3" data-id="element-3576" data-mp="3du9ybmkqy4c9">
                <div className="text-xs text-slate-400 mb-1" data-id="element-3577" data-mp="303n0dwmt8ih8">Expired</div>
                <div className="text-xl font-bold text-white flex items-center" data-id="element-3578" data-mp="302bv1sdpv2o0">
                  {userQuoteStats.expired}
                  <span className="ml-2 text-xs px-1.5 py-0.5 bg-red-900/40 text-red-400 rounded-md" data-id="element-3579" data-mp="2q6iocpmoi3e5">
                    {Math.round(userQuoteStats.expired / userQuoteStats.total * 100)}
                    %
                  </span>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3580" data-mp="2l6nvigjcf3qg">
              <div data-id="element-3581" data-mp="2l90aqlxpuzzt">
                <h5 className="text-sm font-medium text-slate-300 mb-3" data-id="element-3582" data-mp="22iluuhwy1bjh">
                  Quote Distribution
                </h5>
                <div className="h-[200px]" data-id="element-3583" data-mp="1xkafjrnvq8tv">
                  <ResponsiveContainer width="100%" height="100%" data-id="element-3584" data-mp="1xllnm3ocy2qs">
                    <PieChart data-id="element-3585" data-mp="2bk36no3bir2d">
                      <Pie data={quoteDistributionData} cx="50%" cy="50%" innerRadius={60} outerRadius={80} paddingAngle={5} dataKey="value" data-id="element-3586" data-mp="2bh77xxjnbycv">
                        {quoteDistributionData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-3587" data-mp="2lfn1e765bjpj" data-mpi={index} />)}
                      </Pie>
                      <Tooltip contentStyle={{
                      backgroundColor: '#1e293b',
                      borderColor: '#475569',
                      borderRadius: '0.5rem'
                    }} itemStyle={{
                      color: '#e2e8f0'
                    }} formatter={value => [`${value} quotes`, '']} labelFormatter={() => ''} data-id="element-3588" data-mp="2gi4qwcchcwff" />
                    </PieChart>
                  </ResponsiveContainer>
                </div>
                <div className="flex justify-center gap-4 mt-2" data-id="element-3589" data-mp="3jbihmnrud81y">
                  {quoteDistributionData.map(entry => <div key={entry.name} className="flex items-center text-xs" data-id="element-3590" data-mp="3nbspy733wajz">
                      <span className="w-3 h-3 rounded-full mr-1" style={{
                    backgroundColor: entry.color
                  }} data-id="element-3591" data-mp="3s3kk0rlh0yev"></span>
                      <span className="text-slate-300" data-id="element-3592" data-mp="wht819jou56">{entry.name}</span>
                    </div>)}
                </div>
              </div>
              <div data-id="element-3593" data-mp="34dq8qegsvhwq">
                <h5 className="text-sm font-medium text-slate-300 mb-3" data-id="element-3594" data-mp="34d6qewn8mri6">
                  Country Performance
                </h5>
                <div className="h-[200px]" data-id="element-3595" data-mp="39b86r9ta4cpy">
                  <ResponsiveContainer width="100%" height="100%" data-id="element-3596" data-mp="3ebw4eec0jrt5">
                    <BarChart data={countryPerformanceData.slice(0, 5)} layout="vertical" margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5
                  }} data-id="element-3597" data-mp="3ed7c2p8kxjpj">
                      <CartesianGrid strokeDasharray="3 3" horizontal={true} vertical={false} stroke="#475569" data-id="element-3598" data-mp="2e48yk9s2h4un" />
                      <XAxis type="number" stroke="#94a3b8" fontSize={10} data-id="element-3599" data-mp="294cvccr71hg5" />
                      <YAxis dataKey="country" type="category" scale="band" stroke="#94a3b8" fontSize={10} tickLine={false} axisLine={false} width={60} data-id="element-3600" data-mp="24dmpkyeuvckx" />
                      <Tooltip contentStyle={{
                      backgroundColor: '#1e293b',
                      borderColor: '#475569',
                      borderRadius: '0.5rem'
                    }} itemStyle={{
                      color: '#e2e8f0'
                    }} formatter={value => [`$${value.toLocaleString()}`, 'Sales']} data-id="element-3601" data-mp="1zea1698c5xg8" />
                      <Bar dataKey="value" fill="#3b82f6" radius={[0, 4, 4, 0]} data-id="element-3602" data-mp="1gg791lkhrke7" />
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </div>
            </div>
          </div>
          {/* Market Trend */}
          <div className="bg-slate-700/30 rounded-lg p-4 border border-slate-600/50 mb-6" data-id="element-3603" data-mp="3auronjtygpqq">
            <h4 className="text-white font-medium flex items-center mb-4" data-id="element-3604" data-mp="19381wug24tno">
              <TrendingUpIcon size={16} className="mr-2 text-green-400" data-id="element-3605" data-mp="1dwknswtcqmcq" />
              Market Trend
            </h4>
            <div className="h-[250px]" data-id="element-3606" data-mp="z7y0o8xhgqay">
              <ResponsiveContainer width="100%" height="100%" data-id="element-3607" data-mp="145poaqr3hq9c">
                <LineChart data={marketTrendData} margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 20
              }} data-id="element-3608" data-mp="14695g58x8amb">
                  <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#475569" data-id="element-3609" data-mp="1wt2c148zs448" />
                  <XAxis dataKey="month" stroke="#94a3b8" fontSize={10} axisLine={false} tickLine={false} padding={{
                  left: 10,
                  right: 10
                }} data-id="element-3610" data-mp="1itkiycony4p2" />
                  <YAxis stroke="#94a3b8" fontSize={10} axisLine={false} tickLine={false} tickFormatter={value => `$${value / 1000}k`} data-id="element-3611" data-mp="7f77y8f0djqg" />
                  <Tooltip contentStyle={{
                  backgroundColor: '#1e293b',
                  borderColor: '#475569',
                  borderRadius: '0.5rem'
                }} itemStyle={{
                  color: '#e2e8f0'
                }} formatter={value => [`$${value.toLocaleString()}`, 'Sales']} data-id="element-3612" data-mp="bidfrkhrriz1" />
                  <Line type="monotone" dataKey="prevValue" stroke="#94a3b8" strokeWidth={2} strokeDasharray="5 5" dot={false} name="Previous Year" data-id="element-3613" data-mp="dtcu81ncmp1t" />
                  <Line type="monotone" dataKey="value" stroke="#3b82f6" strokeWidth={3} dot={{
                  r: 4,
                  fill: '#3b82f6',
                  strokeWidth: 0
                }} activeDot={{
                  r: 6,
                  fill: '#3b82f6',
                  stroke: '#fff',
                  strokeWidth: 2
                }} name="Current Year" data-id="element-3614" data-mp="3hdh5bwizbpen" />
                </LineChart>
              </ResponsiveContainer>
            </div>
            <div className="flex justify-center gap-6 mt-2 text-xs" data-id="element-3615" data-mp="2tn3bq1kqxihy">
              <div className="flex items-center" data-id="element-3616" data-mp="2tkqxnzi3zsa6">
                <span className="w-3 h-1 bg-blue-500 mr-1 rounded-full" data-id="element-3617" data-mp="284bki5i5mpfn"></span>
                <span className="text-slate-300" data-id="element-3618" data-mp="2d2d915ycngyi">Current Year</span>
              </div>
              <div className="flex items-center" data-id="element-3619" data-mp="2i1psdgq0i5wc">
                <span className="w-3 h-1 bg-slate-400 mr-1 rounded-full" data-id="element-3620" data-mp="2i0wqat2004kj"></span>
                <span className="text-slate-300" data-id="element-3621" data-mp="2m3jn78dj0fol">Previous Year</span>
              </div>
            </div>
          </div>
          {/* Dealers */}
          <div className="bg-slate-700/30 rounded-lg p-4 border border-slate-600/50 mb-6" data-id="element-3622" data-mp="2r0a41xx5nfb2">
            <div className="flex justify-between items-center mb-4" data-id="element-3623" data-mp="2vzmns9sqc69f">
              <h4 className="text-white font-medium flex items-center" data-id="element-3624" data-mp="30tikza165p3j">
                <BuildingIcon size={16} className="mr-2 text-indigo-400" data-id="element-3625" data-mp="35rsfdif2klo3" />
                Dealers
              </h4>
              <div className="flex items-center bg-indigo-900/40 text-indigo-300 border border-indigo-800/30 px-3 py-1 rounded-lg text-sm" data-id="element-3626" data-mp="39tx90h5ipiaq">
                <UsersIcon size={14} className="mr-1.5" data-id="element-3627" data-mp="3epw4eop9k0kn" />
                {dealersStats.total} Total Dealers
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" data-id="element-3628" data-mp="y5974bw6yr0d">
              <div className="bg-slate-800/70 rounded-lg p-3" data-id="element-3629" data-mp="u3xf5zpuhtp0">
                <div className="text-xs text-slate-400 mb-1" data-id="element-3630" data-mp="u475joesy2v8">
                  Active Dealers
                </div>
                <div className="text-xl font-bold text-white" data-id="element-3631" data-mp="p6x4fbi1w2rk">
                  {dealersStats.active}
                </div>
                <div className="text-xs text-green-400 flex items-center mt-1" data-id="element-3632" data-mp="1htrr8f2cbe87">
                  <CheckCircleIcon size={12} className="mr-1" data-id="element-3633" data-mp="1hvvtksklc56d" />
                  {Math.round(dealersStats.active / dealersStats.total * 100)}
                  % active rate
                </div>
              </div>
              <div className="bg-slate-800/70 rounded-lg p-3" data-id="element-3634" data-mp="25iu5dcxrmoxy">
                <div className="text-xs text-slate-400 mb-1" data-id="element-3635" data-mp="25kf0p4rwmbwv">
                  New This Quarter
                </div>
                <div className="text-xl font-bold text-white" data-id="element-3636" data-mp="20qj3w5ndmv3a">
                  {dealersStats.newThisQuarter}
                </div>
                <div className="text-xs text-blue-400 flex items-center mt-1" data-id="element-3637" data-mp="2dg9lpvh2zcmi">
                  <PlusIcon size={12} className="mr-1" data-id="element-3638" data-mp="28h6eq5hjiwbw" />
                  {dealersStats.growthRate}% growth rate
                </div>
              </div>
              <div className="bg-slate-800/70 rounded-lg p-3" data-id="element-3639" data-mp="23jwio6znbmf3">
                <div className="text-xs text-slate-400 mb-1" data-id="element-3640" data-mp="316dc3159dfvk">Top Performer</div>
                <div className="text-base font-bold text-white truncate" data-id="element-3641" data-mp="2w7aj4f2jz03y">
                  {dealersStats.topPerformer}
                </div>
                <div className="text-xs text-amber-400 flex items-center mt-1" data-id="element-3642" data-mp="2rezgv5kcb288">
                  <StarIcon size={12} className="mr-1" data-id="element-3643" data-mp="2mhz9mrbr7tfj" />
                  4.9 rating
                </div>
              </div>
            </div>
            <div data-id="element-3644" data-mp="3jyoaoisvqrnv">
              <h5 className="text-sm font-medium text-slate-300 mb-3 flex items-center" data-id="element-3645" data-mp="3f5v5xuxevjbs">
                <PlusIcon size={14} className="mr-1.5 text-green-400" data-id="element-3646" data-mp="3f41yidez4v2q" />
                Recently Added Dealers
              </h5>
              <div className="overflow-hidden rounded-lg border border-slate-700" data-id="element-3647" data-mp="3rfksd75tt1mo">
                <table className="min-w-full divide-y divide-slate-700" data-id="element-3648" data-mp="9t8uqmk0n8u">
                  <thead className="bg-slate-800/70" data-id="element-3649" data-mp="bw5hti7pemj">
                    <tr data-id="element-3650" data-mp="59615qw72mit">
                      <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider" data-id="element-3651" data-mp="5ah6hv5ag2c1">
                        Dealer
                      </th>
                      <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider" data-id="element-3652" data-mp="e89ley73l7yw">
                        Location
                      </th>
                      <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider" data-id="element-3653" data-mp="nych565lt00x">
                        Added
                      </th>
                      <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-slate-400 uppercase tracking-wider" data-id="element-3654" data-mp="xws91bcggdbh">
                        Initial Sales
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-slate-800/50 divide-y divide-slate-700" data-id="element-3655" data-mp="388hyltib4ux">
                    {dealersStats.newDealers.map((dealer, index) => <tr key={index} className="hover:bg-slate-700/30" data-id="element-3656" data-mp="d8sni0o26viy" data-mpi={index}>
                        <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-white" data-id="element-3657" data-mp="d6fyj3jvvkwe">
                          {dealer.name}
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-300" data-id="element-3658" data-mp="m01damw1t25t">
                          {dealer.location}
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-300" data-id="element-3659" data-mp="vyh40or5y9es">
                          <div className="flex items-center" data-id="element-3660" data-mp="32p6ulv89nibu">
                            <CalendarIcon size={12} className="mr-1.5 text-slate-400" data-id="element-3661" data-mp="32rkldrvwy8dl" />
                            {dealer.date}
                          </div>
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap text-sm text-green-400 font-medium" data-id="element-3662" data-mp="1d94hl32kfw3b">
                          {dealer.sales}
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        {/* Footer */}
        <div className="p-5 border-t border-slate-700 flex justify-between" data-id="element-3663" data-mp="uhuyq36wnuz2">
          <div className="text-sm text-slate-400" data-id="element-3664" data-mp="ujxwxai7ouev">
            Last updated:{' '}
            <span className="text-slate-300" data-id="element-3665" data-mp="ykrk21nty56p">Yesterday at 4:30 PM</span>
          </div>
          <button className="bg-indigo-600 hover:bg-indigo-700 text-white py-2 px-4 rounded-lg transition-colors" onClick={onClose} data-id="element-3666" data-mp="kkytc6cazoyq">
            Close
          </button>
        </div>
      </div>
    </div>;
}